<div class="all-missed-filter">
  <mat-radio-group
    [formControl]="allMissedForm"
    (change)="addFilter('onlyMissed', !!$event.value)"
    aria-label="Select an option"
  >
    <mat-radio-button [value]="0">{{'ALL' | translate}}</mat-radio-button>
    <mat-radio-button [value]="1">{{'MISSED' | translate}}</mat-radio-button>
  </mat-radio-group>
</div>
